import { useEffect } from "react";
import { createFileRoute, redirect } from "@tanstack/react-router";
import Lenis from "lenis";
import { z } from "zod";
import "@fontsource/fragment-mono/latin-400.css";
import "@fontsource/special-gothic-expanded-one/latin-400.css";
import { Arsenal, Bench, Cases, Contact, Footer } from "@/components/soad/Body";
import { Crosshair } from "@/components/soad/Crosshair";
import { reducedMotion, useTheme } from "@/components/soad/hooks";
import { Hero } from "@/components/soad/Hero";
import { Head } from "@/components/soad/Pages";
import { Passes } from "@/components/soad/Passes";
import { Nav, Shown, Statement } from "@/components/soad/Top";
import "@/styles/soad.css";

export const Route = createFileRoute("/")({
  validateSearch: z.object({
    ref: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    if (search.ref) {
      throw redirect({ to: "/waitlist", search: { ref: search.ref } });
    }
  },
  component: StudioPage,
});

function StudioPage() {
  const [theme] = useTheme();

  useEffect(() => {
    if (reducedMotion()) return;
    const lenis = new Lenis({ autoRaf: true, anchors: true });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="sd" data-theme={theme}>
      <Head />
      <Nav home />
      <main>
        <Hero />
        <Shown />
        <Statement />
        <Arsenal />
        <Bench />
        <Cases />
        <Passes />
        <Contact />
      </main>
      <Footer home />
      <Crosshair />
    </div>
  );
}
